console.warn('Common/API/Util plugin')
export default {
    getLocation () {
        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    resolve({
                        longitude: position.coords.longitude,
                        latitue: position.coords.latitude
                    })
                }, reject)
            } else {
                alert('Browser doesn\'t support Geolocation')
                reject(new Error('Browser doesn\'t support Geolocation'))
            }
        })
    },
    loadScript (src, id) {
        id = id || src
        return new Promise((resolve, reject) => {
            let js = document.getElementById(id)
            if (!js) {
                js = document.createElement('script')
                js.src = src
                js.id = id
                let parent = (document.head || document.getElementsByTagName('head')[0] || document.body)
                js.onload = resolve
                js.onerror = function (e) {
                    js.parentNode.removeChild(js)
                    reject(e)
                }
                parent.appendChild(js)
            } else {
                resolve()
            }
        })
    },
    base64 (src) {
        return new Promise((resolve, reject) => {
            var img = new Image()
            img.crossOrigin = 'anonymous'
            img.src = src
            img.onload = () => {
                var canvas = document.createElement('canvas')
                canvas.width = img.width
                canvas.height = img.height
                var ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
                resolve(canvas.toDataURL())
            }
        })
    },
    copy (params) {
        return JSON.parse(JSON.stringify(params))
    },
    format (date) {
        var date_ = new Date(date);
        var year = date_.getFullYear();
        var month = date_.getMonth() + 1;
        var day = date_.getDate();
        if (month < 10) month = "0" + month;
        if (day < 10) day = "0" + day;

        var hours = date_.getHours();
        var mins = date_.getMinutes();
        var secs = date_.getSeconds();
        var msecs = date_.getMilliseconds();
        if (hours < 10) hours = "0" + hours;
        if (mins < 10) mins = "0" + mins;
        if (secs < 10) secs = "0" + secs;
        if (msecs < 10) msecs = "0" + msecs;
        return year + "/" + month + "/" + day + " " + hours + ":" + mins + ":" + secs;
    },
    randomColor () {
        function f0 (color) {
            return (color += '0123456789abcdef'[Math.floor(Math.random() * 16)]) && (color.length === 6) ? color : f0(color)
        }
        return '#' + f0('')
    },
    queryJson (search = '') {
        var json = {}
        search = search || location.search
        search = search.replace('?', '')
        var params = search.split('&')
        params.forEach(item => {
            var ceil = item.split('=')
            if (ceil.length === 2) {
                json[ceil[0]] = decodeURIComponent(ceil[1])
            }
        })
        return json
    },
    parseQuery (href, parse = {}) {
        var pos = href.indexOf('?')
        if (pos > -1) {
            parse.base = href.substr(0, pos)
            parse.query = this.queryJson(href.substr(pos))
        } else {
            parse.base = href
        }
        return parse
    },
    parseHash (href, parse) {
        var pos = href.indexOf('#')
        // 有hash
        if (pos > -1) {
            parse.hash = href.substr(pos)
            href = href.substr(0, pos)
        }
        return href
    },
    parseHashQuery (params, href) {
        href = href || window.location.href
        var parse = {
            base: '',
            hash: '',
            query: {}
        }
        href = this.parseHash(href, parse)
        this.parseQuery(href, parse)
        for (let key in params) {
            parse.query[key] = params[key]
        }
        var query = ''
        for (let key in parse.query) {
            if (parse.query[key]) {
                query += key + '=' + encodeURIComponent(parse.query[key]) + '&'
            }
        }
        if (query) {
            query = '?' + query.substr(0, query.length - 1)
        }
        return parse.base + query + parse.hash
    },
    open(href, force = false) {
        console.log('window.location',window.location)
        console.log('href', href)
        if (!force && this.isMobile) {
            console.log('111')
            window.location.href = href
        } else {
            console.log('222')
            window.open(href)
        }
    },
    reload (params) {
        var l = window.location
        var search = '?'
        for (let key in params) {
            search += key + '=' + params[key] + '&'
        }
        console.warn('reload')
        l.href = l.origin + l.pathname + search + l.hash
        l.reload(true)
    },
    intervalMap: {},
    interval (key, fn, time = 1000) {
        if (this.intervalMap.hasOwnProperty(key)) {
            window.clearInterval(this.intervalMap[key])
            console.warn('stop interval', key)
            delete this.intervalMap[key]
        }
        if (fn) {
            fn()
            console.warn('start interval', key)
            this.intervalMap[key] = setInterval(fn, time)
        }
    },
    isWX: /MicroMessenger/i.test(navigator.userAgent),
    isMobile: navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i),
    groupBy: function (array, f, isArray) { // 数据分组
        var groups = {}
        array.forEach(function (o) {
            var group = f(o)
            groups[group] = groups[group] || []
            groups[group].push(o)
        })
        return isArray ? Object.keys(groups).map(function (group) {
            return groups[group]
        }) : groups
    }
}



// WEBPACK FOOTER //
// ./src/Common/API/util.js